const pl_PL = {
    homepage_title: 'Pobierz CalendarTask wersja mobilna przez kod QR',
    homepage_slogn: 'CalendarTask wersja mobilna',
    homepage_ios_download: 'App Store w trakcie przeglądu...',
    homepage_download: 'Pobierz',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Pobierz CalendarTask wersja mobilna przez kod QR',
    phonedownload_slogan: 'Synchronizacja z PC i tabletem, notatki wszędzie',
    phonedownload_send_vip: 'Zainstaluj aplikację i otrzymaj członkostwo VIP',
    phonedownload_screenshot: 'Zrzut ekranu',
    phodedownload_macos: 'CalendarTask wersja macOS',
    phodedownload_windows: 'CalendarTask wersja Windows',
    phodedownload_otherbutton: 'Zobacz teraz',
    phodedownload_about: 'Kontakt',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Bez reklam',
    feature_easy: 'Widok miesięczny, prosty i łatwy',
    feature_reminder: 'Niestandardowe przypomnienie',
    feature_countdown: 'Odliczanie rocznicy',

    vip_task_succ: 'Sukces. Pobierz aplikację mobilną, aby aktywować VIP',
    vip_task_error: 'Odbieranie nieudane',

    group_slogn: 'Zaproszenie CalendarTask zespół',

    tt_title: 'CalendarTask',
    tt_share_1: 'Udostępniono z Tobą',
    tt_share_2: 'Plan zajęć',
    tt_share_show_1: 'Zeskanuj kod QR aplikacją "CalendarTask", PC i telefon wyświetlą',
    tt_share_show_2: 'plan zajęć',
    tt_share_scan_1: 'Skanuj',
    tt_share_scan_2: 'aplikacją "CalendarTask"',
    tt_share_succ: 'Synchronizacja udana',

    v2_copyright: 'Kontakt service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Wszelkie prawa zastrzeżone.',
    v2_download_appstore: 'Pobierz w App Store',
    v2_download_googleplay: 'Dostępne w Google Play',

    v2_main_title: 'CalendarTask Mobilna',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobilna',
    v2_main_description: 'Szukaj <span class="name">CalendarTask</span> w App Store lub Google Play',
    v2_download_ios: 'Pobierz iOS',
    v2_download_android: 'Pobierz Android',
    v2_download_harmonyos: 'Pobierz HarmonyOS',
    v2_sync_status: 'Synchronizacja zakończona! 1 przesłano, 0 pobrano',
    v2_feature_title: 'Synchronizacja danych wielu urządzeń',
    v2_feature_description: 'Synchronizacja między telefonem, tabletem i PC'
};
export default pl_PL;
